document.addEventListener('DOMContentLoaded', function() {
  function updateButton(form) {
    const variantSelector = form.querySelector('input[name^="variant-"]:checked');
    const addToCartButton = form.querySelector('.quick-add');
    
    if (!variantSelector) return;

    let inStock = !variantSelector.hasAttribute('disabled');

    if (!inStock) {
      addToCartButton.classList.add('out-of-stock');
      addToCartButton.disabled = true;
    } else {
      addToCartButton.classList.remove('out-of-stock');
      addToCartButton.disabled = false;
    }
  }

  document.querySelectorAll('.quick-add').forEach(button => {
    const form = button.closest('.grid-product');

    // עדכון כפתור כאשר הדף נטען
    updateButton(form);

    // האזנה לשינויים בתפריט הווריאנטים
    form.querySelectorAll('input[name^="variant-"]').forEach(input => {
      input.addEventListener('change', () => updateButton(form));
    });

    button.addEventListener('click', function(e) {
      e.preventDefault();
      const productId = this.dataset.productId;
      const variantSelector = form.querySelector(`input[name="variant-${productId}"]:checked`);

      if (!variantSelector) return;

      let variantId = variantSelector.value;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Item added to cart', data);
        updateCartCount();
        updateCartDrawerUI();
      })
      .catch(error => {
        console.error('Error adding item to cart:', error);
      });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart data:', cart);
        const cartCount = cart.item_count;
        const cartBubbleElement = document.querySelector('.cart-link__bubble');

        if (cartBubbleElement) {
          cartBubbleElement.textContent = cartCount;
          cartBubbleElement.style.display = cartCount > 0 ? 'block' : 'none';
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  function updateCartDrawerUI() {
    const event = new CustomEvent('ajaxProduct:added');
    document.dispatchEvent(event);
  }
});
